// ------------------------------------------------------------------
// ASSOCHAM Media Room — central news data, images & filter facets
// ------------------------------------------------------------------

export const IMG = {
  press1:
    "https://images.pexels.com/photos/15920138/pexels-photo-15920138.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  press2:
    "https://images.pexels.com/photos/33317197/pexels-photo-33317197.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  press3:
    "https://images.pexels.com/photos/6950226/pexels-photo-6950226.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  gov1: "https://images.pexels.com/photos/19883686/pexels-photo-19883686.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  gov2: "https://images.pexels.com/photos/19883685/pexels-photo-19883685.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  gov3: "https://images.pexels.com/photos/5548401/pexels-photo-5548401.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  trade1:
    "https://images.pexels.com/photos/93106/pexels-photo-93106.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  trade2:
    "https://images.pexels.com/photos/15346128/pexels-photo-15346128.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  trade3:
    "https://images.pexels.com/photos/1211787/pexels-photo-1211787.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  conf1: "https://images.pexels.com/photos/9275222/pexels-photo-9275222.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  conf2: "https://images.pexels.com/photos/20733081/pexels-photo-20733081.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  conf3: "https://images.pexels.com/photos/8348468/pexels-photo-8348468.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  conf4: "https://images.pexels.com/photos/29708258/pexels-photo-29708258.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  conf5: "https://images.pexels.com/photos/34774344/pexels-photo-34774344.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  solar1:
    "https://images.pexels.com/photos/4320449/pexels-photo-4320449.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  solar2:
    "https://images.pexels.com/photos/4320475/pexels-photo-4320475.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  solar3:
    "https://images.pexels.com/photos/9893731/pexels-photo-9893731.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  data1: "https://images.pexels.com/photos/5480781/pexels-photo-5480781.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  data2: "https://images.pexels.com/photos/17489163/pexels-photo-17489163.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  data3: "https://images.pexels.com/photos/1181316/pexels-photo-1181316.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  hand1: "https://images.pexels.com/photos/6918529/pexels-photo-6918529.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  hand2: "https://images.pexels.com/photos/7792841/pexels-photo-7792841.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  hand3: "https://images.pexels.com/photos/9870223/pexels-photo-9870223.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  edu1: "https://images.pexels.com/photos/3231359/pexels-photo-3231359.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  edu2: "https://images.pexels.com/photos/3231358/pexels-photo-3231358.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  fin1: "https://images.pexels.com/photos/16594725/pexels-photo-16594725.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  fin2: "https://images.pexels.com/photos/35118208/pexels-photo-35118208.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  factory1:
    "https://images.pexels.com/photos/31047145/pexels-photo-31047145.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  factory2:
    "https://images.pexels.com/photos/31336008/pexels-photo-31336008.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
  factory3:
    "https://images.pexels.com/photos/31212954/pexels-photo-31212954.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200",
};

// ------------------------------ facets ------------------------------

export const NEWS_TYPES = [
  "News article",
  "News blog",
  "General publications",
  "News announcement",
  "Press release",
];

export const SUBJECTS = [
  "Artificial intelligence",
  "Business management",
  "Business services",
  "Business start-up",
  "Chemical industry",
  "Circular economy",
  "Climate change policy",
  "Cloud computing",
  "Copyright",
  "Customs regulations",
  "Cybersecurity",
  "Data protection",
  "Digital technology",
  "Digital transformation",
  "Ease of doing business",
  "Economic policy",
  "Economic sector",
  "Education and skills",
  "Electronic commerce",
  "Employment",
  "Energy policy",
  "Environmental policy",
  "Financial markets",
  "Foreign investment",
  "Green economy",
  "Industrial policy",
  "Information technology",
  "Infrastructure",
  "Innovation",
  "Intellectual property",
  "International agreement",
  "International cooperation",
  "International negotiations",
  "International trade",
  "Knowledge transfer and exchange",
  "Labour policy",
  "Legal system",
  "Machine learning",
  "Multilateral agreement",
  "Patent",
  "Pharmaceutical industry",
  "Reduction of gas emissions",
  "Regional cooperation",
  "Renewable energy",
  "Research policy",
  "Small and medium-sized enterprises",
  "Sustainable economic growth strategy",
  "Taxation",
  "Technical regulations",
  "Technology transfer",
  "Trade agreement",
  "Trade relations",
  "Trademark",
].sort();

export const REGIONS = ["Africa", "China", "Europe", "India", "Latin America", "South-East Asia"];

// --------------------------- press coverage --------------------------

export const PRESS_COVERAGE = [
  {
    id: "pc-1",
    title: "Budget 2026: Industry seeks faster tax dispute resolution, easier compliance",
    dateISO: "2025-12-24",
    dateLabel: "Wed, 24 Dec, 2025",
    displayDate: "24 December 2025",
    type: "News article",
    source: "The Economic Times",
    readMins: 4,
    image: IMG.gov1,
    regions: ["India"],
    subjects: ["Taxation", "Economic policy", "Legal system"],
    excerpt:
      "Ahead of the Union Budget, industry chambers led by ASSOCHAM have urged the Finance Ministry to set up fast-track benches for tax dispute resolution and to simplify TDS provisions for MSMEs.",
  },
  {
    id: "pc-2",
    title: "Small Business Confidence Rises Amid Global Challenges, finds ASSOCHAM survey",
    dateISO: "2025-12-22",
    dateLabel: "Mon, 22 Dec, 2025",
    displayDate: "22 December 2025",
    type: "News article",
    source: "Business Standard",
    readMins: 3,
    image: IMG.factory2,
    regions: ["India"],
    subjects: ["Small and medium-sized enterprises", "Economic policy", "Business services"],
    excerpt:
      "The latest ASSOCHAM-Dun & Bradstreet Small Business Confidence Index shows a marked uptick in sentiment, driven by domestic demand, credit flow and easing input costs.",
  },
  {
    id: "pc-3",
    title: "ASSOCHAM to propose policy tweaks for lowering import costs of raw materials",
    dateISO: "2025-12-17",
    dateLabel: "Wed, 17 Dec, 2025",
    displayDate: "17 December 2025",
    type: "News article",
    source: "Mint",
    readMins: 3,
    image: IMG.trade1,
    regions: ["India"],
    subjects: ["International trade", "Customs regulations", "Industrial policy"],
    excerpt:
      "The chamber is preparing a detailed note seeking rationalisation of customs duty on key industrial inputs, arguing that inverted duty structures are hurting domestic manufacturing.",
  },
  {
    id: "pc-4",
    title: "Govt prefers existing laws over new regulations to govern AI, say industry leaders",
    dateISO: "2025-12-16",
    dateLabel: "Tue, 16 Dec, 2025",
    displayDate: "16 December 2025",
    type: "News article",
    source: "The Economic Times",
    readMins: 5,
    image: IMG.data2,
    regions: ["India"],
    subjects: ["Artificial intelligence", "Digital transformation", "Legal system"],
    excerpt:
      "At an ASSOCHAM roundtable, officials signalled that India will lean on existing IT and sectoral frameworks to govern artificial intelligence rather than rush into fresh legislation.",
  },
  {
    id: "pc-5",
    title: "Assocham Urges Fiscal Policy Measures To Ease MSME Working Capital Stress",
    dateISO: "2025-12-15",
    dateLabel: "Mon, 15 Dec, 2025",
    displayDate: "15 December 2025",
    type: "News article",
    source: "NDTV Profit",
    readMins: 3,
    image: IMG.factory3,
    regions: ["India"],
    subjects: ["Small and medium-sized enterprises", "Taxation", "Financial markets"],
    excerpt:
      "ASSOCHAM has pitched for interest subvention on working capital, faster GST refunds and a revival of the credit guarantee window to ease liquidity stress for small businesses.",
  },
  {
    id: "pc-6",
    title: "Duty concessions on auto components in FTA need careful calibration: ASSOCHAM",
    dateISO: "2025-12-10",
    dateLabel: "Wed, 10 Dec, 2025",
    displayDate: "10 December 2025",
    type: "News article",
    source: "Hindu BusinessLine",
    readMins: 4,
    image: IMG.trade2,
    regions: ["India", "Europe"],
    subjects: ["Trade agreement", "International trade", "International negotiations"],
    excerpt:
      "While welcoming progress on the India–EU trade talks, the chamber cautioned that tariff concessions on auto components must be phased to protect the domestic supplier ecosystem.",
  },
  {
    id: "pc-7",
    title: "NTT e-launches Bengaluru data centre, expanding India's digital backbone",
    dateISO: "2025-12-03",
    dateLabel: "Wed, 03 Dec, 2025",
    displayDate: "3 December 2025",
    type: "News announcement",
    source: "Moneycontrol",
    readMins: 2,
    image: IMG.data1,
    regions: ["India"],
    subjects: ["Information technology", "Cloud computing", "Digital technology"],
    excerpt:
      "NTT Global Data Centers marked the virtual launch of its newest Bengaluru facility at an ASSOCHAM digital infrastructure summit, adding critical capacity to South India's cloud corridor.",
  },
  {
    id: "pc-8",
    title: "Afghanistan offers 5-year tax exemption to Indian investors, says ASSOCHAM delegation",
    dateISO: "2025-11-25",
    dateLabel: "Tue, 25 Nov, 2025",
    displayDate: "25 November 2025",
    type: "News article",
    source: "Zee Business",
    readMins: 3,
    image: IMG.hand3,
    regions: ["India"],
    subjects: ["Foreign investment", "Taxation", "International cooperation"],
    excerpt:
      "Kabul has offered a five-year tax holiday and eased visa norms for Indian businesses, an ASSOCHAM delegation announced after trade talks focused on mining, agriculture and pharma.",
  },
  {
    id: "pc-9",
    title: "Fast-track reforms to improve ease of business, says ASSOCHAM President",
    dateISO: "2025-11-21",
    dateLabel: "Fri, 21 Nov, 2025",
    displayDate: "21 November 2025",
    type: "News blog",
    source: "Financial Express",
    readMins: 4,
    image: IMG.gov2,
    regions: ["India"],
    subjects: ["Ease of doing business", "Economic policy", "Business management"],
    excerpt:
      "Decriminalising minor offences, faceless assessments and time-bound clearances top the chamber's reform wishlist to push India into the top 25 on global ease-of-business rankings.",
  },
  {
    id: "pc-10",
    title: "FM Nirmala Sitharaman holds pre-Budget meeting with industry captains",
    dateISO: "2025-11-19",
    dateLabel: "Wed, 19 Nov, 2025",
    displayDate: "19 November 2025",
    type: "News article",
    source: "The Hindu",
    readMins: 3,
    image: IMG.gov3,
    regions: ["India"],
    subjects: ["Economic policy", "Taxation", "Industrial policy"],
    excerpt:
      "The Finance Minister met ASSOCHAM and other industry bodies for pre-Budget consultations, where capex continuity, skilling and customs rationalisation dominated the agenda.",
  },
  {
    id: "pc-11",
    title: "Assocham calls for urgent easing of compliance burden on small exporters",
    dateISO: "2025-11-12",
    dateLabel: "Wed, 12 Nov, 2025",
    displayDate: "12 November 2025",
    type: "News article",
    source: "Business Today",
    readMins: 3,
    image: IMG.conf4,
    regions: ["India"],
    subjects: ["Ease of doing business", "Small and medium-sized enterprises", "International trade"],
    excerpt:
      "The chamber said overlapping filings across DGFT, customs and GST portals are squeezing small exporters and sought a single integrated trade compliance dashboard.",
  },
  {
    id: "pc-12",
    title: "Single window systems in WB, Odisha, Andhra key to 5-year investment plan",
    dateISO: "2025-11-11",
    dateLabel: "Tue, 11 Nov, 2025",
    displayDate: "11 November 2025",
    type: "General publications",
    source: "ET Government",
    readMins: 4,
    image: IMG.conf2,
    regions: ["India"],
    subjects: ["Ease of doing business", "Digital transformation", "Industrial policy"],
    excerpt:
      "An ASSOCHAM study of eastern and southern states found that well-run single-window portals cut project approval timelines by up to 40 percent, anchoring a five-year investment roadmap.",
  },
];

// --------------------------- press releases --------------------------

export const PRESS_RELEASES = [
  {
    id: "pr-1",
    title: "Innovation, Global Collaboration and Climate-Positive Growth Define ASSOCHAM's 2026 Agenda",
    dateISO: "2026-07-09",
    dateLabel: "Thu, 09 Jul, 2026",
    displayDate: "9 July 2026",
    type: "Press release",
    readMins: 4,
    image: IMG.solar3,
    regions: ["India"],
    subjects: ["Innovation", "Climate change policy", "International cooperation"],
    excerpt:
      "Innovation-led research, science-based regulatory frameworks and deepened global partnerships headline the chamber's agenda for building a climate-positive, future-ready Indian economy.",
  },
  {
    id: "pr-2",
    title: "Education must connect learning with employment outcomes, ASSOCHAM tells National Skills Summit",
    dateISO: "2026-07-09",
    dateLabel: "Thu, 09 Jul, 2026",
    displayDate: "9 July 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.edu1,
    regions: ["India"],
    subjects: ["Education and skills", "Employment", "Economic policy"],
    excerpt:
      "Stressing that education must go beyond imparting degrees, ASSOCHAM called for apprenticeship-embedded curricula and closer university-industry pipelines that make every learner employable.",
  },
  {
    id: "pr-3",
    title: "Mutual Fund Industry Poised to Play Pivotal Role in India's Capital Formation",
    dateISO: "2026-07-03",
    dateLabel: "Fri, 03 Jul, 2026",
    displayDate: "3 July 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.fin1,
    regions: ["India"],
    subjects: ["Financial markets", "Economic policy", "Business services"],
    excerpt:
      "Mr. Amarjeet Singh, Whole Time Member, Securities and Exchange Board of India, told an ASSOCHAM capital markets summit that mutual funds will anchor household savings into productive capital.",
  },
  {
    id: "pr-4",
    title: "Green Growth, Faster Environmental Reforms and a Net-Zero Roadmap for Indian Industry",
    dateISO: "2026-07-02",
    dateLabel: "Thu, 02 Jul, 2026",
    displayDate: "2 July 2026",
    type: "Press release",
    readMins: 4,
    image: IMG.solar1,
    regions: ["India"],
    subjects: ["Environmental policy", "Green economy", "Reduction of gas emissions"],
    excerpt:
      "Addressing ASSOCHAM's National Conclave on Building India, leaders from government and industry outlined a pragmatic decarbonisation pathway balancing growth, jobs and energy security.",
  },
  {
    id: "pr-5",
    title: "ASSOCHAM and Afghanistan Chamber of Commerce deepen trade and investment partnership",
    dateISO: "2026-06-23",
    dateLabel: "Tue, 23 Jun, 2026",
    displayDate: "23 June 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.hand1,
    regions: ["India"],
    subjects: ["International cooperation", "International agreement", "Trade relations"],
    excerpt:
      "The Associated Chambers of Commerce and Industry of India (ASSOCHAM) and the Afghanistan Chamber of Commerce agreed to scale bilateral trade in agri-produce, minerals and pharmaceuticals.",
  },
  {
    id: "pr-6",
    title: "Telangana Charting a Bold Vision to Become India's Next Growth Engine",
    dateISO: "2026-05-28",
    dateLabel: "Thu, 28 May, 2026",
    displayDate: "28 May 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.conf2,
    regions: ["India"],
    subjects: ["Economic policy", "Infrastructure", "Industrial policy"],
    excerpt:
      "The Associated Chambers of Commerce and Industry of India (ASSOCHAM) hosted the Telangana Development Dialogue, spotlighting the state's ambitions in life sciences, electronics and logistics.",
  },
  {
    id: "pr-7",
    title: "Global Uncertainty Highlights Importance of Specialty Chemicals Self-Reliance",
    dateISO: "2026-05-21",
    dateLabel: "Thu, 21 May, 2026",
    displayDate: "21 May 2026",
    type: "Press release",
    readMins: 4,
    image: IMG.factory1,
    regions: ["India", "China"],
    subjects: ["Chemical industry", "International trade", "Economic sector"],
    excerpt:
      "India's specialty chemicals sector has become one of the fastest-growing in the world, and ASSOCHAM urged policy support to turn supply-chain volatility into a manufacturing opportunity.",
  },
  {
    id: "pr-8",
    title: "Geopolitical Risks an Opportunity for Faster, Structural Reforms, says ASSOCHAM",
    dateISO: "2026-05-19",
    dateLabel: "Tue, 19 May, 2026",
    displayDate: "19 May 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.conf5,
    regions: ["India"],
    subjects: ["International trade", "Economic policy", "Trade relations"],
    excerpt:
      "As India made significant headway towards becoming a globally trusted supply-chain partner, ASSOCHAM said geopolitical flux should spur faster reforms in logistics, energy and trade facilitation.",
  },
  {
    id: "pr-9",
    title: "Centre Pushes Tech-Led Labour Reform Rollout; States and Industry on Board",
    dateISO: "2026-05-13",
    dateLabel: "Wed, 13 May, 2026",
    displayDate: "13 May 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.data3,
    regions: ["India"],
    subjects: ["Labour policy", "Digital transformation", "Ease of doing business"],
    excerpt:
      "The Government is working closely with states and industry to operationalise the four labour codes through a unified digital compliance stack, officials said at an ASSOCHAM HR summit.",
  },
  {
    id: "pr-10",
    title: "ASSOCHAM formalises the MoU with Viet Nam Chamber of Commerce and Industry",
    dateISO: "2026-05-07",
    dateLabel: "Thu, 07 May, 2026",
    displayDate: "7 May 2026",
    type: "Press release",
    readMins: 2,
    image: IMG.hand2,
    regions: ["India", "South-East Asia"],
    subjects: ["International cooperation", "International agreement", "Trade agreement"],
    excerpt:
      "The MoU was signed in Mumbai by Mr. Saurabh Sanyal, Secretary General, ASSOCHAM, opening new corridors for Indian exporters in electronics, textiles and agri-processing across ASEAN.",
  },
  {
    id: "pr-11",
    title: "69% Patent Filings Now Domestic as India's IP Ecosystem Strengthens",
    dateISO: "2026-05-06",
    dateLabel: "Wed, 06 May, 2026",
    displayDate: "6 May 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.conf3,
    regions: ["India"],
    subjects: ["Patent", "Intellectual property", "Innovation"],
    excerpt:
      "India's intellectual property ecosystem is rapidly evolving, with domestic innovators now accounting for nearly seven of every ten patent filings, an ASSOCHAM- industry report revealed.",
  },
  {
    id: "pr-12",
    title: "India–Africa Dialogue 2026 Curtain Raiser Sets Stage for Deeper Continental Partnership",
    dateISO: "2026-05-05",
    dateLabel: "Tue, 05 May, 2026",
    displayDate: "5 May 2026",
    type: "Press release",
    readMins: 3,
    image: IMG.conf1,
    regions: ["India", "Africa"],
    subjects: ["International cooperation", "Regional cooperation", "Multilateral agreement"],
    excerpt:
      "The Embassy of the Federal Democratic Republic of Ethiopia joined ASSOCHAM at the curtain raiser, previewing ministerial dialogues on trade, digital public infrastructure and skilling.",
  },
];

// ----------------------------- navigation ----------------------------

export const NAV_NEWSROOM = {
  label: "Newsroom",
  href: "/newsroom",
  items: [
    { label: "Press Release", href: "/newsroom/press-release" },
    { label: "Press Coverage", href: "/newsroom/press-coverage" },
    { label: "Image Library", href: "/newsroom/image-library" },
  ],
};

// --------------------------- filter helpers --------------------------

export const DATE_OPTIONS = (() => {
  const all = [...PRESS_COVERAGE, ...PRESS_RELEASES];
  const seen = new Map();
  all.forEach((n) => {
    const d = new Date(n.dateISO);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    const label = d.toLocaleDateString("en-GB", { month: "long", year: "numeric" });
    if (!seen.has(key)) seen.set(key, label);
  });
  return [...seen.entries()]
    .sort((a, b) => (a[0] < b[0] ? 1 : -1))
    .map(([value, label]) => ({ value, label }));
})();

export const EMPTY_FILTERS = {
  keyword: "",
  types: [],
  subjects: [],
  date: "",
  regions: [],
};

export function applyFilters(items, f) {
  return items.filter((it) => {
    if (f.keyword.trim()) {
      const q = f.keyword.trim().toLowerCase();
      const hay = `${it.title} ${it.excerpt} ${it.source ?? ""}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    if (f.types.length && !f.types.includes(it.type)) return false;
    if (f.subjects.length && !it.subjects.some((s) => f.subjects.includes(s))) return false;
    if (f.regions.length && !it.regions.some((r) => f.regions.includes(r))) return false;
    if (f.date) {
      const d = new Date(it.dateISO);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
      if (key !== f.date) return false;
    }
    return true;
  });
}

export function countActive(f) {
  return (
    (f.keyword.trim() ? 1 : 0) + f.types.length + f.subjects.length + (f.date ? 1 : 0) + f.regions.length
  );
}
